const PORTAL_SETTINGS_STORAGE_KEY = 'portalSettings'
const GDPR_ACCEPTATION_KEY = 'gdpr_acceptation'

export { PORTAL_SETTINGS_STORAGE_KEY, GDPR_ACCEPTATION_KEY }
